import { isArray } from 'lodash';
import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import { RootState } from '@redux/store';

const createLengthBasedMemoizedSelector = createSelectorCreator(defaultMemoize, (a, b) => {
  if (isArray(a) && isArray(b)) return a.length === b.length;
  return a === b;
});

export const searchStoreSelector = (state: RootState) => state.searchStore;

export const searchStatusSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.status,
);

export const queryStatusPromptExplorerSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.statusPromptExplorer,
);

export const searchPipelineSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.searchPipeline,
);

export const searchMessageSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.message,
);

export const searchResultSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.searchResults,
);

export const queryResultsPromptExplorerSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.queryResultsPromptExplorer,
);

export const searchSessionsSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.searchSessions,
);

export const searchSessionsStatusSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.searchSessionsStatus,
);

export const referenceDrawerVisibleSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.referenceDrawerVisible,
);

export const promptModalVisibleSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.promptModalVisible,
);

export const activePromptsSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.activePrompts,
);

export const activeReferenceSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.activeReference,
);

export const chatQueryStatusSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.chatQueryStatus,
);

export const chatResultsSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.chatResults,
);

export const queryPipelineParamsSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.queryPipelineParams,
);

// Debug logs

export const debugModeSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.debugMode,
);

export const debugModalConfigSelector = createSelector(
  searchStoreSelector,
  (searchStore) => searchStore.debugModalConfig,
);

export const queryDebugLogSelector = createSelector(
  searchResultSelector,
  (queryResults) => queryResults?._debug || queryResults?.debug || null,
);

export const chatDebugLogListSelector = createSelector(chatResultsSelector, (chatResults) =>
  (chatResults || []).map((chat) => chat.debug || chat._debug).filter(Boolean),
);

export const internalAllDebugLogsSelector = createSelector(
  queryDebugLogSelector,
  chatDebugLogListSelector,
  (queryDebugEntry, chatDebugEntries) => {
    const queryLogs = queryDebugEntry ? [queryDebugEntry] : [];
    const allDebugLogs = [...queryLogs, ...(chatDebugEntries || [])].filter(Boolean);
    return allDebugLogs;
  },
);

export const debugLogsSelector = createLengthBasedMemoizedSelector(
  internalAllDebugLogsSelector,
  (allDebugLogs) => allDebugLogs,
);
